import React, { useEffect, useState } from "react";
import { FaCircle } from "react-icons/fa";
import "./Distributor.css";
import DataTableComponent from "../../components/DataTable";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteDistributorManagementData,
  fetchDistributorManagementData,
} from "../../redux/slice/DistributionRegistrationSlice";
import Loader from "../../components/Common/Loader/PrimaryLoader";
import { RxTriangleDown } from "react-icons/rx";
import DeleteConFirmationModal from "../../components/Common/DeleteConFirmationModal";
import { useNavigate } from "react-router-dom";
import { usePic } from "../../context/PicProvider";

function Distributor() {
  const { setIsLoading } = usePic();
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [modalConfirmTitle, setModalConfirmTitle] = useState("");
  const [showDropCon, setShowDropCon] = useState(false);
  const [downDrop, setDownDrop] = useState(false);
  const [removeId, setRemoveId] = useState([]);
  const [customClass, setCustomClass] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status, DistributorRegisaterData } = useSelector(
    (state) => state.DISTRIBUTORMANAGEMENT
  );
  useEffect(() => {
    dispatch(fetchDistributorManagementData());
  }, [dispatch]);

  const clickRowHandler = (row) => {
    // Redirect to the "update-user" page with the respective ID
    navigate(`/update-distributor/${row._id}`, { state: row });
    // navigate(`/update-distributor`);
  };
  const removeDistributorHandler = async () => {
    setIsLoading(true);
    const res = await dispatch(
      deleteDistributorManagementData({ distributorIds: removeId })
    );
    setIsLoading(false);
    if (res?.payload?.status === 200) {
      dispatch(fetchDistributorManagementData());
      setDeleteConfirm(false);
      setShowDropCon(false);
      setDownDrop(false);
      setRemoveId([]);
    }
  };
  const onSelectedCheckboxChange = (check) => {
    const selectedId = check?.selectedRows.map((curElm) => curElm._id);
    if (selectedId.length > 0) {
      setRemoveId(selectedId);
      setShowDropCon(true);
    } else {
      setRemoveId([]);
      setShowDropCon(false);
    }
  };
  const distColumns = [
    {
      name: "",
      selector: (row) => (
        <div>
          {row.company_logo ? (
            <img src={row.company_logo} alt="logo" className="products-image" />
          ) : (
            <FaCircle color="#E5F0FF" size={50} />
          )}
        </div>
      ),
      width: "90px",
    },
    {
      name: (
        <span
          className={customClass === "1" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("1")}
        >
          Company Name
        </span>
      ),
      selector: (row) => row?.distributor_name,
      sortable: true,
    },
    {
      name: (
        <span
          className={customClass === "2" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("2")}
        >
          Country
        </span>
      ),
      selector: (row) => row.country,
      sortable: true,
    },

    {
      name: (
        <span
          className={customClass === "3" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("3")}
        >
          County
        </span>
      ),
      selector: (row) => row.county,
      sortable: true,
    },
    {
      name: (
        <span
          className={customClass === "4" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("4")}
        >
          Super Admin
        </span>
      ),
      selector: (row) => {
        if (row.role === "distributor_superadmin") {
          return "Super Admin";
        } else {
          // If not distributor_superadmin, return an empty string or some default value
          return ""; // or return some default value
        }
      },
      sortable: true,
    },

    // {
    //   name: (
    //     <span
    //       className={customClass === "5" ? "custom-span-style-for-sorting" : ""}
    //       onClick={() => handleCustomClassForUnderLine("5")}
    //     >
    //       Approver
    //     </span>
    //   ),
    //   selector: (row) => row.alternate_distributor_name,
    //   sortable: true,
    // },
  ];
  if (status === "loading") {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  const userData = DistributorRegisaterData || [];

  const handleCustomClassForUnderLine = (num) => {
    setCustomClass(num);
  };

  const downIconHandler = () => {
    setDownDrop(!downDrop);
  };

  const deleteHandler = () => {
    setDeleteConfirm(true);
    setModalConfirmTitle("Are you sure you want to delete this distributor?");
  };

  // const removeDistributorHandler = async (id) => {
  //   toast.success("Distributor Deleted Successfully");
  //   setDeleteConfirm(false);
  // };

  return (
    <div className="product-management2 position-relative flex-grow-1">
      {userData && userData.length > 0 && showDropCon && (
        <div className="dropdown_icon_style">
          <div onClick={() => downIconHandler()}>
            <RxTriangleDown size={23} />
          </div>
          {downDrop && (
            <div className="event-box-data-user-event-listing">
              <h6 className="cursor" onClick={() => deleteHandler()}>
                Delete{" "}
              </h6>
            </div>
          )}
        </div>
      )}
      <DataTableComponent
        search={false}
        searchBy={["distributor_name", "country", "county"]}
        title={"Distributor Management"}
        columns={distColumns}
        data={userData}
        selectedRows
        clickedRow={clickRowHandler}
        checkboxChange={onSelectedCheckboxChange}
      />
      {deleteConfirm && (
        <DeleteConFirmationModal
          show={deleteConfirm}
          title={modalConfirmTitle}
          eventHandler={removeDistributorHandler}
          hide={() => setDeleteConfirm(false)}
        />
      )}
    </div>
  );
}

export default Distributor;
